function formatDuration(secondsDiff) {
  const isNegative = secondsDiff < 0
  const absoluteSeconds = Math.abs(secondsDiff)

  const hours = Math.floor(absoluteSeconds / 3600)
  const minutes = Math.floor((absoluteSeconds % 3600) / 60)
  const seconds = Math.floor(absoluteSeconds % 60)

  const sign = isNegative ? '-' : ''
  const paddedSeconds = seconds.toString().padStart(2, '0')
  const paddedMinutes = minutes.toString().padStart(2, '0')

  if (hours != 0) return `${sign}${hours}:${paddedMinutes}:${paddedSeconds}`

  return `${sign}${paddedMinutes}:${paddedSeconds}`
}

export default formatDuration
